export interface DealDropBannerProps {
  variant: 'serps' | 'product';
}

const DealDropBanner = ({ variant }: DealDropBannerProps) => {
  return (
    <div className="deal-drop ch-rounded--sm ch-display--flex ch-align-items--center ch-justify-content--between ch-bg--ac-black">
      <div className="ch-mv--2 ch-mh--3">
        <p className="ch-fw--600 ch-fs--4 ch-mb--0 sm:ch-mr--1 ch-color--white">
          Get the new-car feeling{' '}
          <span className="ch-color--ac-yellow">for less.</span>
        </p>
        {variant === 'serps' && (
          <a
            className="ch-color--white ch-fs--1 sm:ch-fs--2 ch-fw--500"
            href="/collections/deal-drop"
          >
            Shop the Deal Drop
          </a>
        )}
      </div>
      <div className="ch-display--flex ch-align-items--center">
        <div className="deal-drop__image--car ch-mv--2 ch-mr--6 ch-display--none sm:ch-display--block"></div>
        <div className="deal-drop__image--logo ch-mv--2 ch-mr--3"></div>
      </div>
    </div>
  );
};

export default DealDropBanner;
